import React from "react";
import {Badge, CardBody, CardText, CardTitle} from "reactstrap";

const WebhookCard = ({data}) => {
  const {
    http_method = "",
    name = "",
    url = "",
    secret = "",
    ssl_verification = false,
  } = data;

  return (
    <CardBody>
      <CardTitle tag="h3">{name} </CardTitle>
      <CardText>{`URL: ${url}`}</CardText>
      <CardText>{`HTTP Method: ${http_method}`}</CardText>
      <CardText>{`Secret: ${secret}`}</CardText>
      <CardText>
        SSL Verification:
        <Badge color="" className="badge-dot ml-2">
          {ssl_verification ? <i className="bg-success" /> : <i className="bg-warning" />}
        </Badge>
      </CardText>
    </CardBody>
  );
};

export default WebhookCard;

export const CustomRenderComponent = ({data}) => {
  const {appliances_name = []} = data;
  return appliances_name.join(", ");
};
